import { useState, useEffect } from 'react';
import { TaskTenantsListForNetworkResponse } from '../../../types/interfaces/task.types';
import * as taskService from '../../../services/taskService';
import { logger } from '../../../services/logger';
import { AxiosError } from 'axios';

interface UseTenantsReturn {
  tenants?: TaskTenantsListForNetworkResponse;
  loading: boolean;
  error: string | null;
  fetchTenants: () => Promise<void>;
}

export const useTenants = (): UseTenantsReturn => {
  const [tenants, setTenants] = useState<TaskTenantsListForNetworkResponse | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTenants = async () => {
    setLoading(true);
    try {
      // Reusing logic from taskService as it provides the tenant list we need
      const tenantsData = await taskService.getTenants();
      setTenants(tenantsData);
      setError(null);
    } catch (err) {
      const message = (err as AxiosError).message || 'Failed to load tenants';
      logger.error('Failed to fetch tenants:', { error: message });
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  return {
    tenants,
    loading,
    error,
    fetchTenants,
  };
};
